/**
 * Service for managing skip link accessibility features.
 * Provides state management for skip navigation functionality.
 */

import { Injectable, signal } from '@angular/core';

/**
 * Service for managing skip link accessibility features.
 *
 * @remarks Provides centralized state management for skip navigation links
 * that allow users to bypass repetitive navigation elements and jump directly
 * to main content. Essential for keyboard navigation and screen reader accessibility.
 *
 */
@Injectable({
  providedIn: 'root',
})
export class SkipLinksService {
  /** @remarks Signal indicating whether a skip link is currently focused */
  isSkipLinkFocused = signal(false);

  /**
   * Sets the focus state of skip links.
   *
   * @remarks Updates the skip link focus state signal to indicate whether
   * a skip link is currently focused. Used to coordinate UI behavior and
   * accessibility features when users interact with skip navigation.
   *
   * @param {boolean} value - True if a skip link is focused, false otherwise
   */
  setFocused(value: boolean): void {
    this.isSkipLinkFocused.set(value);
  }
}
